<template>
  <div>
    <div v-if="showFocus">
      <p>
        White off-focus:
        {{ this.whiteFocuses.filter((f) => !f.tabFocus).length }} times
      </p>
      <p>
        Black off-focus:
        {{ this.blackFocuses.filter((f) => !f.tabFocus).length }} times
      </p>
    </div>
    <div class="is-flex is-align-items-center">
      <span class="mx-3">Zoom</span>
      <b-slider v-model="zoom" :min="1" :max="20" ticks tooltip></b-slider>
    </div>
    <div id="chart_wrapper">
      <GChart
        :settings="{ packages: ['timeline'] }"
        type="Timeline"
        :data="chartData"
        :options="chartOptions"
      />
    </div>
  </div>
</template>

<script>
import MoveHelper from "@/utils/move-helper";
import { formatDate } from "vue-chess-shared/utils/date-helper";
import { firestore } from "@/services/firebase";

export default {
  name: "MoveTimelineChart",

  props: ["match", "moves", "blackToStart", "showFocus"],

  data() {
    return { whiteFocuses: [], blackFocuses: [], zoom: 1 };
  },

  computed: {
    movesStats() {
      return MoveHelper.movesStats(this.match, this.moves, this.blackToStart);
    },

    chartData() {
      return [
        [
          { type: "string", id: "Player" },
          { type: "string", id: "Move" },
          { type: "string", role: "tooltip", p: { html: true } },
          { type: "date", id: "Start" },
          { type: "date", id: "End" },
        ],
        ...(!this.showFocus
          ? []
          : this.whiteFocuses.reduce(
              (rv, x, i) =>
                !x.tabFocus
                  ? [
                      ...rv,
                      [
                        "white focus",
                        "off",
                        null,
                        x.timestamp.toDate(),
                        this.whiteFocuses[i + 1]
                          ? this.whiteFocuses[i + 1].timestamp.toDate()
                          : this.match.endedAt.toDate(),
                      ],
                    ]
                  : rv,
              []
            )),
        ...this.movesStats.flatMap((m, i) => [
          [
            m.color + " move",
            `${m.fullMoveNumber}.${m.move}`,
            `<div>
                ${m.color}&nbsp;move:&nbsp;<b>${m.fullMoveNumber}.${m.move}</b>
                <br/>at:&nbsp;
                <b>${formatDate(m.moveTimestamp, "hh:mm:ss a")}</b>
                <br/>duration:&nbsp;<b>${m.actualMoveTime.toFixed(2)}s</b>
                <br/>buffer:&nbsp;<b>${m.bufferTime.toFixed(2)}s</b>
              </div>`,
            this.moves[i - 1]
              ? this.moves[i - 1].receivedAt &&
                this.moves[i - 1].receivedAt < m.moveTimestamp
                ? this.moves[i - 1].receivedAt.toDate()
                : m.moveTimestamp.toDate()
              : this.match.startedAt.toDate(),
            m.moveTimestamp.toDate(),
          ],
          [
            m.color + " send",
            "",
            null,
            m.moveTimestamp.toDate(),
            m.receivedAt && m.receivedAt > m.moveTimestamp
              ? m.receivedAt.toDate()
              : m.moveTimestamp.toDate(),
          ],
        ]),
        ...(!this.showFocus
          ? []
          : this.blackFocuses.reduce(
              (rv, x, i) =>
                !x.tabFocus
                  ? [
                      ...rv,
                      [
                        "black focus",
                        "off",
                        null,
                        x.timestamp.toDate(),
                        this.blackFocuses[i + 1]
                          ? this.blackFocuses[i + 1].timestamp.toDate()
                          : this.match.endedAt.toDate(),
                      ],
                    ]
                  : rv,
              []
            )),
      ];
    },

    chartOptions() {
      return {
        width: 1170 * this.zoom,
        height: 300,
        chartArea: {
          width: "85%",
          height: "85%",
        },
        timeline: { groupByRowLabel: true, colorByRowLabel: true },
      };
    },
  },

  created() {
    this.$bind(
      "whiteFocuses",
      firestore
        .collection("matches")
        .doc(this.match.id)
        .collection("focuses-white")
        .orderBy("timestamp")
    );
    this.$bind(
      "blackFocuses",
      firestore
        .collection("matches")
        .doc(this.match.id)
        .collection("focuses-black")
        .orderBy("timestamp")
    );
  },
};
</script>

<style scoped>
#chart_wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  /* height: 500px; */
  /* transform: rotate(-90deg); */
}
</style>
